// DEMO-1d (2026-09-25) — is this the demo site?
//
// Asks the backend's public /api/demo/info once per page load and shares the
// answer. That route only exists when the backend runs with DEMO_MODE, so on
// production it 404s and everything demo-related renders nothing. No build
// flag is needed: the same frontend build works for both sites.
import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let pending = null;

export function fetchDemoInfo() {
  if (!pending) {
    pending = axios
      .get(`${API}/demo/info`)
      .then((r) => (r.data && r.data.demo ? r.data : null))
      .catch(() => null);
  }
  return pending;
}

export function useDemoInfo() {
  const [info, setInfo] = useState(null);
  useEffect(() => {
    let alive = true;
    fetchDemoInfo().then((d) => {
      if (alive) setInfo(d);
    });
    return () => {
      alive = false;
    };
  }, []);
  return info;
}
